/**
 * Event Data
 */
 export interface IEvent {
    name: string;
    hours?: string[];
    repeat?: boolean;
    date?: string;
    days?: string[];
    action?: string;
    prompt?: string;
}

/**
 * Model definition of a event within the SSP.
 */
export class Event implements IEvent {
    name!: string;
    hours?: string[];
    repeat?: boolean;
    date?: string;
    days?: string[];
    action?: string;
    prompt?: string;

    constructor(name: string, hours?: string[], repeat?: boolean, date?: string, days?: string[], action?: string, prompt?: string){
        this.name = name;
        this.hours = hours!==undefined ? this.hours : undefined;
        this.repeat = repeat!==undefined ? this.repeat : undefined;
        this.date = date!==undefined ? this.date : undefined;
        this.days = days!==undefined ? this.days : undefined;
        this.action = action!==undefined ? this.action : undefined;
        this.prompt = prompt!==undefined ? this.prompt : undefined;
    }
}